// Chakra imports
import { Flex, FormLabel, FormControl,Input, Text, useColorModeValue, SimpleGrid, Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon, Box, Image } from '@chakra-ui/react';
import Card from 'components/card/Card';

import InputField from "components/fields/InputField";

import tracking from 'assets/img/tracking.png';

export default function Header(props: {
	[x: string]: any;
	data: any;
    expediente: string;
}) {
	const textColorPrimary = useColorModeValue('secondaryGray.900', 'white');
	const textColorSecondary = 'secondaryGray.600';
    const textColor = useColorModeValue("navy.700", "white"); 
    
    if (props.data === undefined || props.data === null || !props.data.cod_Consignatario)        
        return (
            <></>
        );

	return (
        <Flex flexDirection={{ base: 'column' }} mt='15px'>
        <Flex >
            <Text color={textColor} fontSize='28px' fontWeight='700' mb='15px' lineHeight='100%'>
                Detalle del expediente {props.expediente}
			</Text> 
        </Flex> 
		{/* <Image src={tracking}  mb='10px'/> */}
        <Accordion defaultIndex={[0]} allowMultiple>
            <AccordionItem>
                <h2>
                <AccordionButton>
                    <Box as="span" flex='1' textAlign='left'>
                    Cliente
                    </Box>
                    <AccordionIcon />
                </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                <SimpleGrid columns={{ sm: 1, md: 3 , xl: 4}} spacing={{ base: '15px', xl: '15px' }}>
                    <Flex direction='column' >
                    <Text color={textColorPrimary} fontSize='sm' fontWeight='900' ms='2px'>
                            Código
                            </Text>
                        <Text
                                    color={textColorPrimary}
                                    fontSize='sm'
                                    fontWeight='400'
                                    me='14px'>
                                    {props.data.cod_Consignatario}
                                </Text>
                    </Flex>
                    <Flex direction='column' >
                    <Text color={textColorPrimary} fontSize='sm' fontWeight='900' ms='2px'>
                    Nombre
                            </Text>
                        <Text
                                    color={textColorPrimary}
                                    fontSize='sm'
                                    fontWeight='400'
                                    me='14px'>
                                    {props.data.nom_Consignatario}
                                </Text>
                    
                    </Flex>
                    <Flex direction='column'>
                    <Text color={textColorPrimary} fontSize='sm' fontWeight='900' ms='2px'>
                    Expediente
                            </Text>
                        <Text
                                    color={textColorPrimary}
                                    fontSize='sm'
                                    fontWeight='400'
                                    me='14px'>
                                    {props.data.exp_House}
                                </Text>
                    
                    </Flex>
                    <Flex direction='column' >
                    <Text color={textColorPrimary} fontSize='sm' fontWeight='900' ms='2px'>
                    Expediente Aduana
                            </Text>
                        <Text
                                    color={textColorPrimary}
                                    fontSize='sm'
                                    fontWeight='400'
                                    me='14px'>
                                    {props.data.exp_Aduana}
                                </Text>
                    
                    </Flex>
                    <Flex direction='column' >
                    <Text color={textColorPrimary} fontSize='sm' fontWeight='900' ms='2px'>
                    Documento de Transporte
                            </Text>
                        <Text
                                    color={textColorPrimary}
                                    fontSize='sm'
                                    fontWeight='400'
                                    me='14px'>
                                    {props.data.cod_Etapa}
                                </Text>
                        
                    </Flex>
                    <Flex direction='column' >
                    <Text color={textColorPrimary} fontSize='sm' fontWeight='900' ms='2px'>
                    N. Vuelo
                            </Text>
                        <Text
                                    color={textColorPrimary}
                                    fontSize='sm'
                                    fontWeight='400'
                                    me='14px'>
                                    {props.data.vuelo}
                                </Text>                   
                    </Flex>
                    <Flex direction='column' >
                    <Text color={textColorPrimary} fontSize='sm' fontWeight='900' ms='2px'>
                    Nombre del Buque
                            </Text>
                        <Text
                                    color={textColorPrimary}
                                    fontSize='sm'
                                    fontWeight='400'
                                    me='14px'>
                                    
                                </Text>                      
                    </Flex>
                    <Flex direction='column' >
                    <Text color={textColorPrimary} fontSize='sm' fontWeight='900' ms='2px'>
                    N. Viaje
                            </Text>
                        <Text
                                    color={textColorPrimary}
                                    fontSize='sm'
                                    fontWeight='400'
                                    me='14px'>
                                    {props.data.viaje}
                                </Text>                     
                    </Flex>
                    <Flex direction='column' >
                    <Text color={textColorPrimary} fontSize='sm' fontWeight='900' ms='2px'>
                    Origen
                            </Text>
                        <Text
                                    color={textColorPrimary}
                                    fontSize='sm'
                                    fontWeight='400'
                                    me='14px'>
                                    {props.data.origen}
                                </Text>  
                    
                    </Flex>
                    <Flex direction='column' >
                    <Text color={textColorPrimary} fontSize='sm' fontWeight='900' ms='2px'>
                    Destino
                            </Text>
                        <Text
                                    color={textColorPrimary}
                                    fontSize='sm'
                                    fontWeight='400'
                                    me='14px'>
                                    {props.data.destino}
                                </Text> 
                    
                    </Flex>
                    </SimpleGrid>
                </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
                <h2>
                <AccordionButton>
                    <Box as="span" flex='1' textAlign='left'>
                    Embarcador
                    </Box>
                    <AccordionIcon />
                </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                <SimpleGrid columns={{ sm: 1, md: 3 , xl: 4}} spacing={{ base: '15px', xl: '15px' }}>
                    <Flex direction='column' >
                    <Text color={textColorPrimary} fontSize='sm' fontWeight='900' ms='2px'>
                    Nombre
                            </Text>
                        <Text
                                    color={textColorPrimary}
                                    fontSize='sm'
                                    fontWeight='400'
                                    me='14px'>
                                    {props.data.nom_Embarcador}
                                </Text>
                    </Flex>
                    <Flex direction='column' >
                    <Text color={textColorPrimary} fontSize='sm' fontWeight='900' ms='2px'>
                    Oficina
                            </Text>
                        <Text
                                    color={textColorPrimary}
                                    fontSize='sm'
                                    fontWeight='400'
                                    me='14px'>
                                    {props.data.oficina}
                                </Text>
                    
                    </Flex>
                    <Flex direction='column'>
                    <Text color={textColorPrimary} fontSize='sm' fontWeight='900' ms='2px'>
                    Operación
                            </Text>
                        <Text
                                    color={textColorPrimary}
                                    fontSize='sm'
                                    fontWeight='400'
                                    me='14px'>
                                    {props.data.operacion}
                                </Text>
                    
                    </Flex>
                    <Flex direction='column' >
                    <Text color={textColorPrimary} fontSize='sm' fontWeight='900' ms='2px'>
                    Embarque
                            </Text>
                        <Text
                                    color={textColorPrimary}
                                    fontSize='sm'
                                    fontWeight='400'
                                    me='14px'>
                                    {props.data.embarque}
                                </Text>
                    
                    </Flex>
                    <Flex direction='column' >
                    <Text color={textColorPrimary} fontSize='sm' fontWeight='900' ms='2px'>
                    Tipo
                            </Text>
                        <Text
                                    color={textColorPrimary}
                                    fontSize='sm'
                                    fontWeight='400'
                                    me='14px'>
                                    {props.data.tipo}
                                </Text>
                        
                    </Flex>                    
                    </SimpleGrid>
                </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
                <h2>
                <AccordionButton>
                    <Box as="span" flex='1' textAlign='left'>
                    Referencia
                    </Box>
                    <AccordionIcon />
                </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                <SimpleGrid columns={{ sm: 1, md: 3 , xl: 4}} spacing={{ base: '15px', xl: '15px' }}>
                    <Flex direction='column' >
                    <Text color={textColorPrimary} fontSize='sm' fontWeight='900' ms='2px'>
                    Código de Ref.
                            </Text>
                        <Text
                                    color={textColorPrimary}
                                    fontSize='sm'
                                    fontWeight='400'
                                    me='14px'>
                                    {props.data.referencia}
                                </Text>
                    </Flex>                                       
                    </SimpleGrid>
                </AccordionPanel>
            </AccordionItem>
        </Accordion> 
        </Flex>          
	);
}
